<template>
  <div>
    <module-quiz
      :readonly="
        role != 'SUPERADMIN' &&
        !permissions.includes('LD') &&
        !permissions.includes('TEACHER')
          ? true
          : false
      "
      v-if="$route.params.type == 'Quiz'"
    />
    <module-attendance
      :readonly="
        role != 'SUPERADMIN' &&
        !permissions.includes('LD') &&
        !permissions.includes('TEACHER')
          ? true
          : false
      "
      v-if="$route.params.type == 'Attendance'"
    />
    <module-assignment
      :readonly="
        role != 'SUPERADMIN' &&
        !permissions.includes('LD') &&
        !permissions.includes('TEACHER')
          ? true
          : false
      "
      v-if="$route.params.type == 'Assignment'"
    />
    <module-material
      :readonly="
        role != 'SUPERADMIN' &&
        !permissions.includes('LD') &&
        !permissions.includes('TEACHER')
          ? true
          : false
      "
      v-if="$route.params.type == 'Materi'"
    />
    <module-assessment
      :readonly="
        role != 'SUPERADMIN' &&
        !permissions.includes('LD') &&
        !permissions.includes('TEACHER')
          ? true
          : false
      "
      v-if="$route.params.type == 'Assessment'"
    />
    <module-synchronous
      :readonly="
        role != 'SUPERADMIN' &&
        !permissions.includes('LD') &&
        !permissions.includes('TEACHER')
          ? true
          : false
      "
      v-if="$route.params.type == 'Synchronous'"
    />
    <module-group-project
      :readonly="
        role != 'SUPERADMIN' &&
        !permissions.includes('LD') &&
        !permissions.includes('TEACHER')
          ? true
          : false
      "
      v-if="$route.params.type == 'GroupProject'"
    />
    <module-indie-project
      :readonly="
        role != 'SUPERADMIN' &&
        !permissions.includes('LD') &&
        !permissions.includes('TEACHER')
          ? true
          : false
      "
      v-if="$route.params.type == 'IndividuProject'"
    />
  </div>
</template>

<script>
import ModuleAssessment from "./moduleAssessment.vue";
import ModuleAssignment from "./moduleAssignment.vue";
import ModuleAttendance from "./moduleAttendance.vue";
import ModuleGroupProject from "./moduleGroupProject.vue";
import ModuleMaterial from "./moduleMaterial.vue";
import moduleQuiz from "./moduleQuiz.vue";
import { mapState } from "vuex";
import ModuleSynchronous from "./moduleSynchronous.vue";
import ModuleIndieProject from "./moduleIndieProject.vue";
export default {
  components: {
    moduleQuiz,
    ModuleAttendance,
    ModuleAssignment,
    ModuleMaterial,
    ModuleAssessment,
    ModuleGroupProject,
    ModuleSynchronous,
    ModuleIndieProject,
  },
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  name: "configModule",
  data() {
    return {};
  },

  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
